import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prefix($this, level, loggerName) {
  var tmp;
  if ($this.u2f_1) {
    tmp = level.v1_1 + ': [' + loggerName + '] ';
  } else {
    tmp = '';
  }
  return tmp;
}
function throwableToString($this, $receiver) {
  return createThrowableMsg($this, '', $receiver);
}
function createThrowableMsg($this, msg, throwable) {
  var $this_0 = $this;
  var msg_0 = msg;
  var throwable_0 = throwable;
  $l$1: do {
    $l$0: do {
      var tmp;
      if (throwable_0 == null || equals(throwable_0.cause, throwable_0)) {
        tmp = msg_0;
      } else {
        var tmp0 = $this_0;
        var tmp1 = msg_0 + ", Caused by: '" + throwable_0.message + "'";
        var tmp2 = throwable_0.cause;
        $this_0 = tmp0;
        msg_0 = tmp1;
        throwable_0 = tmp2;
        continue $l$0;
      }
      return tmp;
    }
     while (false);
  }
   while (true);
}
var DefaultMessageFormatterClass;
function DefaultMessageFormatter() {
  if (DefaultMessageFormatterClass === VOID) {
    class $ {
      constructor(includePrefix) {
        includePrefix = includePrefix === VOID ? true : includePrefix;
        this.u2f_1 = includePrefix;
      }
      s2f(loggingEvent) {
        // Inline function 'kotlin.with' call
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().l1();
        this_0.m1(prefix(this, loggingEvent.v2f_1, loggingEvent.x2f_1));
        var tmp0_safe_receiver = loggingEvent.w2f_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c2g();
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          this_0.m1(tmp1_safe_receiver);
          this_0.m1(' ');
        }
        this_0.m1(loggingEvent.y2f_1);
        this_0.m1(throwableToString(this, loggingEvent.z2f_1));
        return this_0.toString();
      }
    }
    initMetadataForClass($, 'DefaultMessageFormatter', DefaultMessageFormatter);
    DefaultMessageFormatterClass = $;
  }
  return DefaultMessageFormatterClass;
}
//region block: exports
export {
  DefaultMessageFormatter as DefaultMessageFormatter17x784jf2u2xo,
};
//endregion

//# sourceMappingURL=Formatter.mjs.map
